export const meta = {
  title: '隐私政策 | PDFCraftTool',
  description:
    'PDFCraftTool.org（独立的 PdfCraft 下载与对比指南站）如何处理访客数据、Cookie、账号以及 PdfCraft 在线版。',
  updated_at: '2026-10-15',
};

## 关于本政策

PDFCraftTool 运营 pdfcrafttool.org，这是一个关于 PdfCraft 的独立指南站。PdfCraft 是 ArtCraft 团队开发的免费开源 PDF 编辑器。本站提供 PdfCraft 下载链接、安装指南、使用教程、与 Adobe Acrobat 的功能对比，以及托管的 PdfCraft 网页版。本政策说明我们处理哪些信息、为什么处理，以及你拥有的选择。如有疑问，请联系 [support@pdfcrafttool.org](mailto:support@pdfcrafttool.org)。

PDFCraftTool 与 ArtCraft 及 Adobe 均无隶属关系。你安装或使用 PdfCraft 软件本身时，适用的是该软件的许可证和 ArtCraft 的相关政策，而非本政策。

## 无需账号即可使用本站

阅读指南、对比 PdfCraft 与 Acrobat、下载 PdfCraft 以及使用 PdfCraft 在线版都不需要注册账号，我们也不会要求你提供姓名或邮箱。

## PdfCraft 在线版与你的文件

PdfCraft 在线版是本站托管的一份未经修改的 PdfCraft WebAssembly 版本（由 ArtCraft 发布于 github.com/storytold/pdfcraft），完全在你的浏览器标签页内运行。你在其中打开的 PDF 由浏览器在你自己的设备上读取，**绝不会上传**到我们的服务器。我们无法查看、保存或恢复你打开的文档。你在应用中设置的偏好保存在浏览器的本地存储中。

## 下载

所有 PdfCraft 下载按钮都直接链接到 GitHub 上的 PdfCraft 发布文件（github.com/storytold/pdfcraft/releases）。点击后，你的浏览器会连接 GitHub，该请求适用 GitHub 的隐私声明。我们不托管也不修改任何安装包。

## 自动收集的信息

- **服务器与安全日志：** IP 地址、浏览器与设备类型、访问的页面、来源页面和时间戳，用于运行网站、保障安全和调查滥用行为。
- **统计分析：** 我们可能使用 Google Analytics、Plausible 或 Microsoft Clarity 等注重隐私的分析工具，了解哪些指南对访客有用。这些工具可能使用 Cookie 或类似技术，记录浏览的页面、点击、滚动、大致位置和设备信息。Clarity 可能生成会话回放，并默认遮盖表单中输入的文字。
- **偏好设置：** 你选择的语言（Cookie）以及浅色或深色主题（浏览器存储）。

## 可选账号与客服

如果你选择注册账号或联系客服，我们会处理你的邮箱地址、姓名、头像（如使用 Google 登录）、登录会话以及你发送给我们的消息。登录链接等事务性邮件由我们的邮件服务商（Resend）发送。

## 我们与谁共享信息

我们只在必要范围内，与帮助我们运营网站的服务商共享信息：托管、存储与安全（Cloudflare）、邮件发送（Resend）、登录（Google，如你选择使用）以及上文列出的统计工具。我们不出售你的个人信息，也不会为广告画像而共享。法律要求时，我们可能依法披露信息。

## 保存期限

服务器日志仅为安全目的保存有限时间。统计数据按各服务商的设置保存。账号信息在账号存续期间保存，在你要求注销后 30 天内删除，法律要求保留的记录除外。

## 你的权利与选择

你可以在浏览器中屏蔽或删除 Cookie，网站仍可正常使用。如需查阅、更正、导出或删除你的个人信息，请发送邮件至 [support@pdfcrafttool.org](mailto:support@pdfcrafttool.org)。根据你所在地区的法律，你还可能有权反对某些处理，或向数据保护机构投诉。

## 儿童

PDFCraftTool 是面向普通用户的技术指南站，并非针对 13 岁以下儿童。我们不会在知情的情况下收集儿童的个人信息。

## 政策变更

当网站或我们的数据处理方式发生变化时，我们可能更新本政策。页面顶部日期为最新修订日期。
